module.exports = __webpack_public_path__ + "img/uaa-logo.53659a15.png";